(() => {
  if (customElements.get('st-melo-gallery')) return;
  class MeloGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.slides = [...this.querySelectorAll('[data-melo-slide]')];
      this.thumbs = [...this.querySelectorAll('[data-melo-index]')];
      this.track = this.querySelector('[data-melo-track]');
      this.current = 0;
      this.thumbs.forEach((button, index) => button.addEventListener('click', () => {
        if (!this.dragged) this.select(index);
      }));
      this.querySelector('[data-melo-prev]').addEventListener('click', () => {
        this.track.scrollBy({left: -this.track.clientWidth * .8, behavior: 'smooth'});
      });
      this.querySelector('[data-melo-next]').addEventListener('click', () => {
        this.track.scrollBy({left: this.track.clientWidth * .8, behavior: 'smooth'});
      });
      let startX = 0, startScroll = 0, dragging = false;
      this.track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        startX = e.clientX;
        startScroll = this.track.scrollLeft;
        dragging = true;
        this.dragged = false;
      });
      this.track.addEventListener('pointermove', e => {
        if (!dragging) return;
        const difference = e.clientX - startX;
        if (Math.abs(difference) > 6) {
          this.dragged = true;
          this.track.scrollLeft = startScroll - difference;
          e.preventDefault();
        }
      });
      const stop = () => {
        dragging = false;
        setTimeout(() => { this.dragged = false; }, 0);
      };
      this.track.addEventListener('pointerup', stop);
      this.track.addEventListener('pointerleave', stop);
      this.track.addEventListener('dragstart', e => e.preventDefault());
      this.dialog = this.querySelector('dialog');
      this.slides.forEach(slide => slide.addEventListener('click', () => {
        const original = slide.querySelector('img');
        const large = this.dialog.querySelector('img');
        large.src = original.currentSrc || original.src;
        large.alt = original.alt;
        this.dialog.showModal();
      }));
      this.dialog.querySelector('button').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => {if(e.target === this.dialog) this.dialog.close();});
      this.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          this.select((this.current + (e.key === 'ArrowRight' ? 1 : -1) + this.slides.length) % this.slides.length);
          this.thumbs[this.current]?.focus({preventScroll: true});
        }
      });
      this.select(0, false);
      const productInfo = this.closest('product-info');
      const selectVariant = variant => {
        const source = variant?.featured_image?.src || variant?.featured_media?.preview_image?.src;
        if (!source) return;
        const file = value => {
          try { return new URL(value, location.origin).pathname.split('/').pop(); }
          catch { return ''; }
        };
        const target = file(source);
        const index = this.slides.findIndex(slide => file(slide.querySelector('img')?.src || '') === target);
        if (index >= 0) this.select(index, false);
      };
      try {
        selectVariant(JSON.parse(productInfo?.querySelector('[data-selected-variant]')?.textContent || 'null'));
      } catch {}
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.variantUnsubscribe?.();
        this.variantUnsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
          if (String(data.sectionId) === String(productInfo?.dataset.section)) selectVariant(data.variant);
        });
      }

    }
    select(index, scroll = true) {
      this.current = index;
      this.slides.forEach((slide, n) => {
        slide.hidden = n !== index;
        slide.classList.toggle('is-active', n === index);
      });
      this.thumbs.forEach((thumb, n) => {
        thumb.classList.toggle('is-active', n === index);
        thumb.setAttribute('aria-pressed', String(n === index));
      });
      if (scroll) {
        const thumb = this.thumbs[index];
        if (thumb) this.track.scrollTo({left: thumb.offsetLeft - this.track.offsetLeft - (this.track.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth'});
      }
    }
  }
  customElements.define('st-melo-gallery', MeloGallery);
  document.addEventListener('submit', e => {
    const form = e.target.closest('[data-melo-buy-now]');
    if (!form) return;
    const main = form.closest('.st-melo-main');
    const nativeForm = main.querySelector('product-form form');
    const nativeSubmit = nativeForm?.querySelector('[type="submit"]');
    if (!nativeForm || nativeSubmit?.disabled) {
      e.preventDefault();
      return;
    }
    const quantity = main.querySelector('.quantity__input');
    if (quantity && !quantity.reportValidity()) {
      e.preventDefault();
      quantity.focus();
      return;
    }
    const selected = nativeForm.querySelector('[name="id"]');
    form.querySelector('[name="id"]').value = selected.value;
    form.querySelector('[name="quantity"]').value = quantity?.value || '1';
    form.querySelectorAll('[data-melo-copied-property]').forEach(input => input.remove());
    for (const [name, value] of new FormData(nativeForm)) {
      if ((name === 'selling_plan' || name.startsWith('properties[')) && typeof value === 'string') {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.setAttribute('data-melo-copied-property', '');
        form.append(input);
      }
    }
  });
  document.addEventListener('click', e => {
    const carouselButton = e.target.closest('[data-melo-carousel-prev],[data-melo-carousel-next]');
    if (carouselButton) {
      const track = carouselButton.closest('[data-melo-carousel-root],.st-melo-community')?.querySelector('[data-melo-carousel]');
      if (!track) return;
      track.scrollBy({left: track.clientWidth * .8 * (carouselButton.hasAttribute('data-melo-carousel-prev') ? -1 : 1),behavior: 'smooth'});
    }
    const add = e.target.closest('[data-melo-add]');
    const buy = e.target.closest('[data-melo-buy]');
    if (add || buy) {
      const bar = (add || buy).closest('[data-melo-purchase-bar]');
      const main = document.getElementById(bar.dataset.mainId);
      if (!main) return;
      const submit = main.querySelector('product-form [type="submit"]');
      const nativeCheckout = main.querySelector('[data-melo-buy-now] [type="submit"]');
      const acceleratedCheckout = main.querySelector('.shopify-payment-button');
      if (add && submit && !submit.disabled) {
        submit.click();
      } else if (buy && nativeCheckout && !nativeCheckout.disabled) {
        nativeCheckout.click();
      } else if (buy && acceleratedCheckout) {
        acceleratedCheckout.scrollIntoView({behavior: 'smooth',block: 'center'});
        const checkoutControl = acceleratedCheckout.querySelector('shopify-accelerated-checkout,[role="button"],button');
        if (checkoutControl instanceof HTMLElement) checkoutControl.focus({preventScroll: true});
      } else {
        const target = buy ? nativeCheckout || submit : submit;
        (target || main.querySelector('.product__info-wrapper') || main).scrollIntoView({behavior: 'smooth',block: 'center'});
        if (target instanceof HTMLElement) target.focus({preventScroll: true});
      }
    }
    const returnButton = e.target.closest('[data-melo-return]');
    if (returnButton) {
      e.preventDefault();
      document.querySelector('.st-melo-main .product__info-wrapper')?.scrollIntoView({behavior: 'smooth',block: 'start'});
    }
  });
  const updateBars = () => {
    document.querySelectorAll('[data-melo-purchase-bar]').forEach(bar => {
      const main = document.getElementById(bar.dataset.mainId);
      const submit = main?.querySelector('product-form [type="submit"]');
      const add = bar.querySelector('[data-melo-add]');
      const buy = bar.querySelector('[data-melo-buy]');
      if (submit) {
        if (add.disabled !== submit.disabled) add.disabled = submit.disabled;
        if (buy.disabled !== submit.disabled) buy.disabled = submit.disabled;
        const buyNow = main.querySelector('[data-melo-buy-now] [type="submit"]');
        if (buyNow && buyNow.disabled !== submit.disabled) buyNow.disabled = submit.disabled;
        add.innerHTML = submit.querySelector('span')?.innerHTML || submit.textContent;
      }
    });
  };
  const observer = new MutationObserver(updateBars);
  document.querySelectorAll('.st-melo-main .product__info-wrapper').forEach(main => observer.observe(main,{childList: true,subtree: true,attributes: true,attributeFilter: ['disabled']}));
  updateBars();
  document.addEventListener('shopify:section:load', updateBars);
})();
